import { Card, Typography, Box, Tooltip } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import {
  colorAppBackground,
  colorLinkGrey,
  colorPureWhite,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import {
  AUDIO_RESOURCE_SMALL_ICON,
  AUDIO_RESOURCES_ICON,
  DOC_RESOURCE_SMALL_ICON,
  DOC_RESOURCES_ICON,
  FLASHCARD_RESOURCE_SMALL_ICON,
  FLASHCARD_RESOURCES_ICON,
  IMAGE_RESOURCE_SMALL_ICON,
  LIKE_HEART_ICON,
  LIKE_ICON,
  PDF_RESOURCE_SMALL_ICON,
  PDF_RESOURCES_ICON,
  PPT_RESOURCE_SMALL_ICON,
  PPT_RESOURCES_ICON,
  VIDEO_RESOURCE_SMALL_ICON,
  XLS_RESOURCE_SMALL_ICON,
  XLS_RESOURCES_ICON
} from '../../utils/imageUrls';
import { useNavigate } from 'react-router-dom';
import MoreActionsComponent from './MoreActionsComponent';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  addContentViews,
  addHistory,
  deleteGamification,
  gamification,
  updateLikeDislike
} from '../../redux/reducers/resourcesSlice';
import {
  formatDateTimeAgo,
  getContentCardThumbnailUrl,
  handleError
} from '../../utils/utils';
import SnackBarBox from '../../components/SnackBarBox';

const ContentCard = ({ video, sectionID, tags = [] }) => {
  const uploadType = video?.upload_type || video?.uploadType;
  const urlParams = new URLSearchParams(location.search);
  const paramSectionId = urlParams.get('sectionId');

  const { authData } = useSelector(state => state.auth);
  const {
    isSaveToWatchLaterLoading,
    isSaveToWatchLaterSuccess,
    isSaveToWatchLaterFailed,
    saveToWatchLaterResponse,
    saveToWatchLaterErrorContainer,
    isUpdateLikeDislikeLoading,
    isUpdateLikeDislikeSuccess,
    isUpdateLikeDislikeFailed,
    updateLikeDislikeResponse,
    updateLikeDislikeErrorContainer
  } = useSelector(state => state.resource);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOnClick = (
    encryptedContentId,
    sectionId,
    contentId,
    contentType
  ) => {
    const resolvedType = contentType || uploadType || '';
    const isFlashcard =
      resolvedType.replace(/\s+/g, '').toLowerCase() === 'flashcard';

    let payload = {
      contentId: contentId || 0,
      userId: authData?.userId || 0,
      loggedInUserName: authData?.userName || ''
    };
    dispatch(addHistory({ payload }));

    if (isFlashcard) {
      navigate(
        `/content-space/view-flashcard?id=${encryptedContentId}&sectionId=${sectionId || paramSectionId}`,
        {
          state: {
            tags: tags,
            path: location.pathname
          }
        }
      );
      let payload = {
        contentId: contentId || 0,
        userId: authData?.userId || 0,
        loggedInUserName: authData?.userName || ''
      };
      dispatch(addContentViews({ payload }));
    } else {
      navigate(
        `/content-space/view?id=${encryptedContentId}&sectionId=${sectionId}`,
        {
          state: {
            tags: tags,
            path: location.pathname
          }
        }
      );
    }
  };

  const handleLikeDislike = (e, video) => {
    e.stopPropagation();

    let LikePayload = {
      contentId: video?.content_id || 0,
      loggedInUserName: authData?.userName || ''
    };

    let disLikePayload = {
      contentId: video?.content_id || 0,
      loggedInUserName: authData?.userName || '',
      userId: authData?.userId || 0
    };

    let payload = video?.contentLikes === 'No' ? LikePayload : disLikePayload;
    let contentLike = video?.contentLikes;

    dispatch(updateLikeDislike({ payload, contentLike }));
    // if (authData?.role === 'I am a student') {
    //   if (video?.allow_points && video?.contentLikes === 'Yes') {
    //     let payload = {
    //       userId: authData?.userId || 0,
    //       contentId: video?.content_id || 0,
    //       loggedInUserName: authData?.userName || ''
    //     };
    //     dispatch(deleteGamification({ payload }));
    //   }

    //   if (video?.allow_points && video?.contentLikes === 'No') {
    //     let gamificationPayload = {
    //       userId: authData?.userId || 0,
    //       contentId: video?.content_id || 0,
    //       point: video?.likes_points || 0,
    //       type: 'like',
    //       loggedInUserName: authData?.userName || ''
    //     };
    //     dispatch(gamification({ gamificationPayload }));
    //   }
    // }
  };

  return (
    <>
      {uploadType === 'Video' || uploadType === 'Image' ? (
        <Card
          sx={{
            boxShadow: 'none',
            border: '1px solid #CBD2D9',
            cursor: 'pointer',
            backgroundColor: colorAppBackground,
            padding: '12px',
            height: '100%',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            borderRadius: '8px',
            minWidth: '238px'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '5px',
              alignItems: 'center'
            }}
            onClick={() =>
              handleOnClick(
                video?.encrypted_content_id,
                sectionID,
                video?.content_id,
                video?.upload_type
              )
            }
          >
            <Box marginBottom={1}>
              <img
                src={
                  video?.upload_type === 'Image'
                    ? IMAGE_RESOURCE_SMALL_ICON
                    : video?.upload_type === 'Video'
                      ? VIDEO_RESOURCE_SMALL_ICON
                      : PPT_RESOURCE_SMALL_ICON
                }
                alt="thumbnail"
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  maxWidth: '100%',
                  display: 'block'
                }}
              />
            </Box>

            <div
              style={{
                width: '26px',
                height: '26px',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={e => handleLikeDislike(e, video)}
            >
              <img
                className="imgbox"
                src={
                  video?.contentLikes === 'Yes' ? LIKE_HEART_ICON : LIKE_ICON
                }
                alt="Like Icon"
                width={15}
                height={15}
                style={{
                  cursor: 'pointer'
                }}
              />
            </div>
          </div>

          <div style={{ position: 'relative', width: '100%', height: '121px' }}>
            <img
              src={getContentCardThumbnailUrl(video)}
              alt="PDF thumbnail"
              style={{
                width: '100%',
                height: '121px',
                objectFit: 'fill',
                borderRadius: '8px'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            />

            {/* Duration Overlay */}
            {uploadType === 'Video' && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '5px',
                  right: '5px',
                  backgroundColor: colorTextBlack,
                  borderRadius: '5px',
                  padding: '5px'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 700,
                    fontFamily: 'Lato',
                    color: colorPureWhite
                  }}
                >
                  {video?.duration || '00:00'}
                </Typography>
              </div>
            )}
          </div>

          <div style={{ marginTop: '0.5rem' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontFamily: 'Lato',
                  fontSize: '16px',
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: '20px'
                }}
                onClick={() =>
                  handleOnClick(
                    video?.encrypted_content_id,
                    sectionID,
                    video?.content_id,
                    video?.upload_type
                  )
                }
              >
                {video.title}
              </Typography>

              <div style={{ marginLeft: '10px' }}>
                <MoreActionsComponent data={video} />
              </div>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#ABB4BD',
                gap: 1,
                fontWeight: 500,
                fontFamily: 'Lato',
                fontSize: '14px',
                lineHeight: '18px',
                marginTop: '10px'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            >
              <VisibilityOutlined fontSize="small" />
              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                {video.views}
              </Typography>

              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                •
              </Typography>
              <Typography
                style={{
                  fontSize: '14px',
                  fontFamily: 'Lato',
                  lineHeight: '18px',
                  fontWeight: 500,
                  color: colorTextGrey
                }}
              >
                {video.updated_dt ? formatDateTimeAgo(video.updated_dt) : '-'}
              </Typography>
            </Box>
          </div>
        </Card>
      ) : uploadType === 'POWERPOINT' ||
        uploadType === 'MSWORD' ||
        uploadType === 'EXCEL' ||
        uploadType === 'PDF' ||
        uploadType === 'Flashcard' ? (
        <>
          <Card
            sx={{
              boxShadow: 'none',
              border: '1px solid #CBD2D9',
              cursor: 'pointer',
              backgroundColor: colorAppBackground,
              padding: '12px',
              height: '100%',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              borderRadius: '8px',
              minWidth: '238px'
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                alignItems: 'center'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            >
              <Box marginBottom={1}>
                <img
                  src={
                    video?.upload_type === 'POWERPOINT'
                      ? PPT_RESOURCE_SMALL_ICON
                      : video?.upload_type === 'MSWORD'
                        ? DOC_RESOURCE_SMALL_ICON
                        : video?.upload_type === 'EXCEL'
                          ? XLS_RESOURCE_SMALL_ICON
                          : video?.upload_type === 'PDF'
                            ? PDF_RESOURCE_SMALL_ICON
                            : video?.upload_type === 'Flashcard'
                              ? FLASHCARD_RESOURCE_SMALL_ICON
                              : PPT_RESOURCE_SMALL_ICON
                  }
                  alt="Audio thumbnail"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    maxWidth: '100%',
                    display: 'block'
                  }}
                />
              </Box>

              <div
                style={{
                  width: '26px',
                  height: '26px',
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onClick={e => handleLikeDislike(e, video)}
              >
                <img
                  className="imgbox"
                  src={
                    video?.contentLikes === 'Yes' ? LIKE_HEART_ICON : LIKE_ICON
                  }
                  alt="Like Icon"
                  width={15}
                  height={15}
                  style={{
                    cursor: 'pointer'
                  }}
                />
              </div>
            </div>

            <img
              src={getContentCardThumbnailUrl(video)}
              alt="PDF thumbnail"
              style={{
                width: '100%',
                height: '121px',
                objectFit: 'fill',
                borderRadius: '8px'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            />

            <div style={{ marginTop: '0.5rem' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'Lato',
                    fontSize: '16px',
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '20px'
                  }}
                  onClick={() =>
                    handleOnClick(
                      video?.encrypted_content_id,
                      sectionID,
                      video?.content_id,
                      video?.upload_type
                    )
                  }
                >
                  {video.title}
                </Typography>

                <div style={{ marginLeft: '10px' }}>
                  <MoreActionsComponent data={video} />
                </div>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#ABB4BD',
                  gap: 1,
                  fontWeight: 500,
                  fontFamily: 'Lato',
                  fontSize: '14px',
                  lineHeight: '18px',
                  marginTop: '10px'
                }}
                onClick={() =>
                  handleOnClick(
                    video?.encrypted_content_id,
                    sectionID,
                    video?.content_id,
                    video?.upload_type
                  )
                }
              >
                <VisibilityOutlined fontSize="small" />
                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  {video.views}
                </Typography>

                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  •
                </Typography>
                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  {video.updated_dt ? formatDateTimeAgo(video.updated_dt) : '-'}
                </Typography>
              </Box>
            </div>
          </Card>
        </>
      ) : uploadType === 'Audio' ? (
        <>
          <Card
            sx={{
              boxShadow: 'none',
              position: 'relative',
              border: '1px solid #CBD2D9',
              cursor: 'pointer',
              backgroundColor: colorAppBackground,
              padding: '12px',
              height: '100%',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              borderRadius: '8px',
              minWidth: '238px'
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                alignItems: 'center'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            >
              <Box marginBottom={1}>
                <img
                  src={AUDIO_RESOURCE_SMALL_ICON}
                  alt="Audio thumbnail"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    maxWidth: '100%',
                    display: 'block'
                  }}
                />
              </Box>

              <div
                style={{
                  width: '26px',
                  height: '26px',
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onClick={e => handleLikeDislike(e, video)}
              >
                <img
                  className="imgbox"
                  src={
                    video?.contentLikes === 'Yes' ? LIKE_HEART_ICON : LIKE_ICON
                  }
                  alt="Like Icon"
                  width={15}
                  height={15}
                  style={{
                    cursor: 'pointer'
                  }}
                />
              </div>
            </div>

            <img
              src={getContentCardThumbnailUrl(video)}
              alt="Audio thumbnail"
              style={{
                width: '100%',
                height: '121px',
                objectFit: 'fill',
                borderRadius: '8px'
              }}
              onClick={() =>
                handleOnClick(
                  video?.encrypted_content_id || video?.encryptedContentId,
                  sectionID,
                  video?.content_id || video?.contentId,
                  uploadType
                )
              }
            />

            <div style={{ marginTop: '0.5rem' }}>
              {/* Title with Menu Icon */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'Lato',
                    fontSize: '16px',
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '20px'
                  }}
                  onClick={() =>
                    handleOnClick(
                      video?.encrypted_content_id,
                      sectionID,
                      video?.content_id,
                      video?.upload_type
                    )
                  }
                >
                  {video.title}
                </Typography>

                <div style={{ marginLeft: '10px' }}>
                  <MoreActionsComponent data={video} />
                </div>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#ABB4BD',
                  gap: 1,
                  fontWeight: 500,
                  fontFamily: 'Lato',
                  fontSize: '14px',
                  lineHeight: '18px',
                  marginTop: '10px'
                }}
                onClick={() =>
                  handleOnClick(
                    video?.encrypted_content_id,
                    sectionID,
                    video?.content_id,
                    video?.upload_type
                  )
                }
              >
                <VisibilityOutlined fontSize="small" />
                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  {video.views}
                </Typography>

                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  •
                </Typography>
                <Typography
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Lato',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: colorTextGrey
                  }}
                >
                  {video.updated_dt ? formatDateTimeAgo(video.updated_dt) : '-'}
                </Typography>
              </Box>
            </div>
          </Card>
        </>
      ) : (
        <></>
      )}

      {!isSaveToWatchLaterLoading &&
        isSaveToWatchLaterSuccess &&
        saveToWatchLaterResponse && (
          <SnackBarBox
            type="success"
            message={handleError(saveToWatchLaterResponse?.payload?.message)}
          />
        )}

      {!isSaveToWatchLaterLoading &&
        saveToWatchLaterErrorContainer &&
        isSaveToWatchLaterFailed && (
          <SnackBarBox
            type="error"
            message={handleError(saveToWatchLaterErrorContainer?.errorMessage)}
          />
        )}

      {!isUpdateLikeDislikeLoading &&
        isUpdateLikeDislikeSuccess &&
        updateLikeDislikeResponse && (
          <SnackBarBox
            type="success"
            message={handleError(updateLikeDislikeResponse?.payload?.message)}
          />
        )}

      {!isUpdateLikeDislikeLoading &&
        updateLikeDislikeErrorContainer &&
        isUpdateLikeDislikeFailed && (
          <SnackBarBox
            type="error"
            message={handleError(updateLikeDislikeErrorContainer?.errorMessage)}
          />
        )}
    </>
  );
};

export default ContentCard;
